import type { TargetingProviderConfig } from '@openx/types/targeting/targetingProviderConfig';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';

export const useFetchInventoryMarket: TargetingProviderConfig['useFetchInventoryMarket'] = () => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: { path: 'deal.package.targeting.content.market_operators' },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [{ name: 'All Markets' }];
    }

    const list = optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
    return [{ name: 'All Markets' }, ...list];
  }, [optionsByPath]);

  const _mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  return { loading, markets: list };
};
